import React from 'react'

function index() {
  return (
    <div>MyCourses</div>
  )
}

export default index